module.exports = __webpack_public_path__ + "static/media/samtoddest.b0b32693.png";